module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('template', {
    slot: "activator"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-list', [(_vm.canRemove) ? _c('v-list-tile', {
    on: {
      "click": _vm.remove
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.remove)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canExclude) ? _c('v-list-tile', {
    on: {
      "click": _vm.exclude
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.exclude)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canCancel) ? _c('v-list-tile', {
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.cancel)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canUncancel) ? _c('v-list-tile', {
    on: {
      "click": _vm.uncancel
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.uncancel)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canSetStart) ? _c('v-list-tile', {
    on: {
      "click": _vm.setStart
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.setStart)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canSetEnd) ? _c('v-list-tile', {
    on: {
      "click": _vm.setEnd
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.setEnd)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canMove) ? _c('v-list-tile', {
    on: {
      "click": _vm.moveStart
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "offset-y": "",
      "full-width": "",
      "transition": "scale-transition",
      "min-width": "290px",
      "color": "primary",
      "close-on-content-click": false,
      "nudge-right": 40
    },
    model: {
      value: (_vm.moving),
      callback: function($$v) {
        _vm.moving = $$v
      },
      expression: "moving"
    }
  }, [_c('v-list-tile-title', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.move)
    }
  })]), _vm._v(" "), (_vm.movingDate) ? _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.targetDate),
      callback: function($$v) {
        _vm.targetDate = $$v
      },
      expression: "targetDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.movingDate = false
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerCancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": _vm.moveEnd
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerOk))])], 1) : _vm._e(), _vm._v(" "), (_vm.movingTime) ? _c('v-time-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.targetTime),
      callback: function($$v) {
        _vm.targetTime = $$v
      },
      expression: "targetTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.movingTime = false
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerCancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.moveEnd
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerOk))])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.canInclude) ? _c('v-list-tile', {
    on: {
      "click": _vm.includeStart
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "offset-y": "",
      "full-width": "",
      "transition": "scale-transition",
      "min-width": "290px",
      "color": "primary",
      "close-on-content-click": false,
      "nudge-right": 40
    },
    model: {
      value: (_vm.including),
      callback: function($$v) {
        _vm.including = $$v
      },
      expression: "including"
    }
  }, [_c('v-list-tile-title', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.include)
    }
  })]), _vm._v(" "), (_vm.includingDate) ? _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.targetDate),
      callback: function($$v) {
        _vm.targetDate = $$v
      },
      expression: "targetDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.includingDate = false
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerCancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.includeEnd
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerOk))])], 1) : _vm._e(), _vm._v(" "), (_vm.includingTime) ? _c('v-time-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.targetTime),
      callback: function($$v) {
        _vm.targetTime = $$v
      },
      expression: "targetTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.includingTime = false
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerCancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.includeEnd
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerOk))])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("scheduleActionsAdditional", null, null, {
    schedule: _vm.schedule,
    calendarEvent: _vm.calendarEvent,
    calendar: _vm.calendar
  })], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0472c64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleActions.vue
// module id = 429
// module chunks = 1